import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";

export const getExpenseListAllUnit = async(params?: Record<string, any>) => {
  const response = await axiosInstance.get(API_ENDPOINTS.EXPENSE.GET_EXPENSE_LIST_ALL_UNITS, {params:params} );
  return response.data;
};

export const getEmployeeListByUnit = async (params?: Record<string, any>, id?: number) => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.EXPENSE.GET_EMPLOYEE_LIST_BY_UNIT}/${id}`,
    { params }
  );
  const formatedData = Array.isArray(response?.data?.data.data)?response?.data?.data.data : []
  const totalRecord = response?.data?.data?.recordsTotal ?? 0;
  return {formatedData,totalRecord}
};

export const getExpenseByEmployeeId = async (params?: Record<string, any>, id?: number) => {

  const response = await axiosInstance.get(
    `${API_ENDPOINTS.EXPENSE.GET_EXPENSE_BY_EMPLOYEE_ID}/${id}`,
    { params }
  );

  return response.data;
}

export const getExpenseListByDate = async (params?: Record<string, any>, id?: number) => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.EXPENSE.GET_EXPENSE_LIST_BY_DATE}/${id}`,
    { params }
  );
  return response.data;
}


export const getExpenseDetails = async (id?: number) => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.EXPENSE.GET_EXPENSE_DETAILS}/${id}`
  );
  return response.data;
  // console.log('response_data',response.data);
}

export const getExpenseFWDetails = async (empId?: number,params?:Record<string,any>) => {
  // console.log("id", empId);
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.EXPENSE.GET_EXPENSE_FW_DETAILS}/${empId}`,{params}
  );
  return response.data;
}

export const getExpenseNCADetails = async (empId?: number,params?:Record<string,any>) => {
  // console.log("id", empId);
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.EXPENSE.GET_EXPENSE_NCA_DETAILS}/${empId}`,{params}
  );
  return response.data;
}

export const getExpenseLog = async (id?: number,params?:Record<string,any>) => {
  // console.log("id", empId);
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.EXPENSE.GET_EXPENSE_LOG}/${id}`,{params}
  );
  return response.data;
}

export const updateExpenseAmount = async (id?: number,params?:Record<string,any>) => {
  // console.log("id", empId);
  const response = await axiosInstance.put(
    `${API_ENDPOINTS.EXPENSE.PUT_UPDATE_EXPESEN_AMOUNT}/${id}`,params
  );
  return response.data;
}

export const getExpenseStatus = async ()=>{
  let response =  await axiosInstance.get(`${API_ENDPOINTS.EXPENSE.GET_EXPENSE_STATUS}`);
  const rowData = await response?.data; 

  const formatedData  = Object.entries(rowData.data || {} ).map(([Key,value])=>({
    id:Key,
    label:value
  }))
  return{formatedData,rowData};
}

export const getDarReportspecificEmp = async(params:any)=>{
  const response = await axiosInstance.get(`${API_ENDPOINTS.EXPENSE.GET_DAR_REPORT}`,{params});
  const rowData = await response.data;
  console.log('rowData',rowData);
   const formatedData =  Array.isArray(rowData?.data?.darData)?
   rowData?.data.darData.map((item:any,index:number)=>({
    Sr_No:index + 1,
    Stownname:item.Stownname,
    OutletName:item.OutletName,
    Tags:item.Tags,
    Agenda:item.Agenda,
    JointWorking:item.JointWorking,
    Planned:item.Planned, 
    CreatedAt:item.CreatedAt,  
    SgpiOut:item.SgpiOut,
    PobTotal:item.PobTotal, 
    Potential:item.Potential, 
    Contribution:item.Contribution, 
    Edetailing:item.Edetailing,
    Sgpi:item.Sgpi
  })):[]
  
  return{formatedData,rowData};
}  


export const UpdateExpenseStatus_proceedToPayment = async(ReqBody:any)=>{
    const response = await axiosInstance.put(API_ENDPOINTS.EXPENSE.PUT_UPDATE_EXPENSE_STATUS,ReqBody);
    console.log('data===>',response?.data);
}